import { Directive, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';

@Directive({
  selector: '[appObserveResize]',
  exportAs: 'resizeObserver',
})
export class ObserveResizeDirective implements OnInit, OnDestroy {
  @Input() box: ResizeObserverBoxOptions = 'border-box';
  @Output() readonly resized = new EventEmitter<ResizeObserverEntry>();
  private readonly observer = new ResizeObserver(([entry]) => {
    this.resized.emit(entry);
  });

  constructor(private readonly element: ElementRef) {}

  ngOnInit(): void {
    if (this.element) {
      this.observer.observe(this.element.nativeElement, {
        box: this.box,
      });
    }
  }

  ngOnDestroy(): void {
    this.observer.disconnect();
  }
}
